import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import LogoSvg from './LogoSvg';
import ThemeToggle from './ThemeToggle';
import { useLogoAnimation } from '../lib/useLogoAnimation';

/**
 * Top navigation bar. Class names are styled by src/styles/app.css.
 *
 * The theme toggle ships in two variants:
 *  - `inline` lives next to the nav links on desktop
 *  - `fab` is a floating button pinned to the bottom-right on mobile
 * CSS hides whichever variant doesn't apply at the current breakpoint.
 */
export default function PageNav() {
  const [mobileActive, setMobileActive] = useState(false);
  const navRef = useRef<HTMLElement>(null);
  useLogoAnimation(navRef);
  const close = () => setMobileActive(false);

  return (
    <>
      <nav ref={navRef} className={`page-nav fixed${mobileActive ? ' open' : ''}`}>
        <div className="nav-bg"></div>
        <div className="container relative">
          <div className="row">
            <div className="col-xs-12">
              <div className="pull-left">
                <a href="/" className="nav-logo clearfix" onClick={close}>
                  <LogoSvg />
                  <span className="logo-name">Chris Boustead</span>
                </a>
              </div>
              <button
                className="mobile-icon"
                onClick={() => setMobileActive((v) => !v)}
                aria-label="Toggle navigation menu"
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <div className={`pull-right nav${mobileActive ? ' open' : ''}`}>
                <NavLink to="/" end onClick={close} className={({ isActive }) => (isActive ? 'active' : '')}>
                  Portfolio
                </NavLink>
                <NavLink to="/resume" onClick={close} className={({ isActive }) => (isActive ? 'active' : '')}>
                  Resume
                </NavLink>
                <NavLink to="/contact" onClick={close} className={({ isActive }) => (isActive ? 'active' : '')}>
                  Contact
                </NavLink>
                <div className="nav-desktop-toggle">
                  <ThemeToggle variant="inline" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Floating theme toggle — visible only on mobile breakpoints. */}
      <ThemeToggle variant="fab" />
    </>
  );
}
